module.exports = __webpack_public_path__ + "img/appStatus_active.07a0d488.svg";